import { render, staticRenderFns } from "./loyalty-single-offer.vue?vue&type=template&id=69224207&scoped=true"
import script from "./loyalty-single-offer.ts?vue&type=script&lang=ts&external"
export * from "./loyalty-single-offer.ts?vue&type=script&lang=ts&external"
import style0 from "./loyalty-single-offer.scss?vue&type=style&index=0&id=69224207&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69224207",
  null
  
)

export default component.exports